import { Tooltip } from "@material-ui/core";
import React, { useState, useRef, useEffect } from "react";

const DropdownSelect = ({
  tab,
  model,
  dd,
  searchPlaceHolderText,
  selectInfoText,
  selectedValue,
  menuList,
  textWidth,
  popperWidth,
  popperHeight,
  disabled,
  onUpdate,
  onCreate,
  onChange,
  width = null,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [dropUp, setDropUp] = useState(false);

  const dropdownRef = useRef(null);

  const filteredItems = menuList.filter((item) =>
    item.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleDropdown = () => {
    const dropdown = dropdownRef.current;
    const dropdownRect = dropdown.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (dropdownRect.bottom + 200 > viewportHeight) {
      setDropUp(true);
    } else {
      setDropUp(false);
    }

    setIsOpen(!isOpen);

    if (!isOpen) {
      setSearchTerm("");
    }
  };

  const handleChange = (item) => {
    if (tab === "models") {
      onUpdate(model, item?.regionId);
    } else if (tab === "DD-ConfigType") {
      onUpdate(model, dd, item);
    } else if (tab === "DD-ColumnType") {
      onUpdate(model, dd, item);
    } else if (tab === "RulesLayer") {
      // console.log(item);
      onChange(item.label);
    }
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);
    handleChange(item);
    setIsOpen(false);
    setSearchTerm("");
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setSearchTerm("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const styles = {
    dropdown: {
      position: "relative",
      width: "300px",
      fontFamily: "Arial, sans-serif",
      borderRadius: "3px",
    },
    dropdownHeader: {
      padding: "10px",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: width ? width : "100%",
    },
    dropdownBody: {
      position: "absolute",
      width: "100%",
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 4px",
      backgroundColor: "white",
      zIndex: 1000,
      top: dropUp ? "auto" : "100%",
      bottom: dropUp ? "100%" : "auto",
    },
    dropdownSearch: {
      width: "280px",
      padding: "8px 10px",
      border: "none",
      backgroundColor: "#d1e9fd",
      outline: "none",
    },
    dropdownList: {
      padding: "5px 10px 10px 10px",
    },
    dropdownTitle: {
      color: "#888",
      fontSize: "14px",
    },
    dropdownItem: {
      padding: "4px 8px",
      fontSize: "14px",
      fontWeight: "400",
      color: "#333333",
      margin: "10px 0",
      backgroundColor: "rgb(238, 238, 238)",
      cursor: "pointer",
      borderRadius: "3px",
      textAlign: "center",
      width: "fit-content",
    },
    dropdownItemHover: {
      backgroundColor: "#e1e1e1",
    },
    arrow: {
      fontSize: "11px",
      marginLeft: "auto",
      paddingLeft: "10px",
    },
  };

  return (
    <>
      <div style={styles.dropdownHeader} onClick={toggleDropdown}>
        <Tooltip
          title={selectedItem?.label || selectedValue}
          placement="right-start"
          arrow
        >
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "inherit",
            }}
          >
            {selectedItem?.label || selectedValue}
          </span>
        </Tooltip>

        <span style={styles.arrow}>{"▼"}</span>
      </div>
      <div style={styles.dropdown} ref={dropdownRef}>
        {isOpen && (
          <div style={styles.dropdownBody}>
            <div>
              <input
                type="text"
                placeholder="SEARCH FOR A VIEW"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={styles.dropdownSearch}
              />
            </div>
            <div style={styles.dropdownList}>
              <div style={styles.dropdownTitle}>Select a View</div>
              {filteredItems.length ? (
                filteredItems.map((item) => (
                  <div
                    key={item.label}
                    style={styles.dropdownItem}
                    onClick={() => handleItemClick(item)}
                    onMouseEnter={(e) =>
                      (e.target.style.backgroundColor =
                        styles.dropdownItemHover.backgroundColor)
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.backgroundColor =
                        styles.dropdownItem.backgroundColor)
                    }
                  >
                    {item.label}
                  </div>
                ))
              ) : (
                <div>No Options Found</div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DropdownSelect;
